import { StyleSheet } from 'react-native';
import { Colors } from '@qnpm/q-theme';
import SizeUtil, {ScreenHeight} from "../../Utils/SizeUtil";
import { DeviceInfo } from 'qunar-react-native';

const { isMini } = DeviceInfo;
const { scenes: { baseColor } } = Colors;

export default StyleSheet.create({
    orderListCompWrapper: {
        flex: 1,
        backgroundColor: baseColor.background2,
        marginTop:-2,
    },
    orderListComp: {
        flex: 1,
        height: isMini ? ScreenHeight - SizeUtil.getRootViewY() + 18 : ScreenHeight - SizeUtil.getRootViewY() // fix me
        // backgroundColor:'red'
        // paddingTop:-50,
    },
    refreshControl: {
        backgroundColor: baseColor.background2
    },
    refreshControlIcon: {
        color: '#999',
        marginRight: 4
    },
    refreshControlText: {
        fontSize: 14,
        color: '#999'
    },
    trainLimitTipView: {
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1
    },
    trainLimitTipText: {
        fontSize: 14,
        color: '#999'
    },
    cacheBar: {
        margin: 10,
        padding: 5,
        borderRadius: 5,
        backgroundColor: '#ccc',
        alignItems: 'center'
    },
    cacheBarText: {
        fontSize: 14,
        color: '#000'
    },
    loadMoreContainer: {
        paddingBottom:20
    },
    privateCont:{
        // flexWrap: "wrap"
        // width:'100%',
    },
    privateContHint1:{
        // width:'100%',
        fontWeight:'bold',
        paddingBottom:10,
    },
    privateContHint2:{
        // width:'100%',
        color:'#999'
    },
    orderMergeWrap:{
        paddingHorizontal: 12,
        paddingTop: 11,
        backgroundColor:baseColor.background2
    },
    orderMergeView:{
        overflow:'hidden',
        borderRadius:8,
        backgroundColor:baseColor.background2
    }
});
